(function(){
"use strict";

/* ── Theme toggle ─────────────────────────────────────────────────────── */
var RG_THEME_KEY = "mct-rg-theme";
var rgRoot = document.querySelector(".mct-rg");
function rgSetTheme(m){
  if(!rgRoot) return;
  rgRoot.setAttribute("data-rg-theme", m);
  try{ localStorage.setItem(RG_THEME_KEY, m); }catch(e){}
}
(function(){
  var saved; try{ saved=localStorage.getItem(RG_THEME_KEY); }catch(e){}
  rgSetTheme(saved==="light"?"light":"dark");
})();

document.addEventListener("DOMContentLoaded", function(){

  /* theme toggle btn */
  var tBtn = document.getElementById("rgThemeToggle");
  if(tBtn) tBtn.addEventListener("click", function(){
    var cur = rgRoot ? rgRoot.getAttribute("data-rg-theme") : "dark";
    rgSetTheme(cur==="dark"?"light":"dark");
  });

  /* image fallback */
  document.querySelectorAll("img[data-rg-fallback]").forEach(function(img){
    img.addEventListener("error", function(){
      var ph = document.createElement("div");
      ph.className = "rg-ph";
      ph.style.cssText = "width:100%;height:100%;aspect-ratio:4/3";
      if(img.parentNode) img.parentNode.replaceChild(ph, img);
    });
  });

  /* ── Scrollspy ─────────────────────────────────────────────────────── */
  var sections = Array.from(document.querySelectorAll(".rg-content > section[id]"));
  var links = {};
  document.querySelectorAll(".rg-toc-link").forEach(function(l){
    var id = l.getAttribute("href").replace(/^.*#/,"");
    links[id] = l;
  });
  var mobileSel = document.getElementById("rgTocMobile");
  var current = null;
  function setActive(id){
    if(id===current) return; current=id;
    Object.keys(links).forEach(function(k){ links[k].classList.toggle("active", k===id); });
    if(mobileSel && mobileSel.value!==id) mobileSel.value=id;
  }
  if("IntersectionObserver" in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting) setActive(en.target.id); });
    },{rootMargin:"-20% 0px -72% 0px",threshold:0}).observe.bind(
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting) setActive(en.target.id); });
      },{rootMargin:"-20% 0px -72% 0px",threshold:0})
    );
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting) setActive(en.target.id); });
    },{rootMargin:"-20% 0px -72% 0px",threshold:0});
    sections.forEach(function(s){ io.observe(s); });
  }
  if(mobileSel) mobileSel.addEventListener("change", function(){
    var el = document.getElementById(mobileSel.value);
    if(el) el.scrollIntoView({behavior:"smooth",block:"start"});
  });

  /* ── FAQ accordion ─────────────────────────────────────────────────── */
  document.querySelectorAll(".rg-faq-item").forEach(function(item){
    var q = item.querySelector(".rg-faq-q");
    var a = item.querySelector(".rg-faq-a");
    q.addEventListener("click", function(){
      var open = item.classList.contains("open");
      if(open){
        a.style.maxHeight = a.scrollHeight+"px";
        requestAnimationFrame(function(){ a.style.maxHeight="0px"; });
        item.classList.remove("open");
        q.setAttribute("aria-expanded","false");
      } else {
        item.classList.add("open");
        q.setAttribute("aria-expanded","true");
        a.style.maxHeight = a.scrollHeight+"px";
        a.addEventListener("transitionend", function te(){
          if(item.classList.contains("open")) a.style.maxHeight="none";
          a.removeEventListener("transitionend",te);
        });
      }
    });
  });

  /* ── Layer stack (Systemaufbau) — tabbed ──────────────────────────── */
  /* Layer data — supports both Dünnschicht (noppe/klett) and Klettsystem (slim/silent/duennschicht) */
  var layerDataByStack = {
    /* ── Dünnschicht ── */
    noppe: {
      belag:   {step:"Schicht 6 · oben",  name:"Bodenbelag",                        h:"frei wählbar",  body:"Fliesen, Parkett, Vinyl oder Laminat – nach kurzer Trocknungszeit direkt auf den Dünnschicht-Estrich verlegt. Wärmewiderstand λ ≤ 0,15 m²K/W empfohlen."},
      estrich: {step:"Schicht 5",          name:"Dünnschicht-Estrich (Calciumsulfat-Ausgleichsmasse)",h:"≥ 5 mm",        body:"Faserverstärkte Calciumsulfat-Ausgleichsmasse. Begehbar nach 3 Stunden, Belag nach 4–12 Std. belegreif. Ca. 1,4 kg/m² je mm Schichtdicke – etwas Reserve einplanen."},
      rohr:    {step:"Schicht 4",          name:"Heizrohr PE-RT / PE-Xa",            h:"10 – 16 mm",    body:"Rohr wird per Druck-Knopf-Technik in die Noppen geclipst. Frei wählbarer Rohrabstand. Max. 70 m pro Heizkreis empfohlen."},
      folie:   {step:"Schicht 3",          name:"Noppenfolie (Druck-Knopf)",         h:"5 – 13 mm",     body:"Selbstklebende Noppenfolie mit Druck-Knopf-System. Kein Werkzeug nötig. Die Perforation lässt Calciumsulfat-Ausgleichsmasse direkt mit dem Untergrund verkleben."},
      grund:   {step:"Schicht 2",          name:"Grundierung / Haftbrücke",          h:"hauchdünn",     body:"Untergrund reinigen und grundieren, damit die Noppenfolie und der Estrich dauerhaft haften."},
      boden:   {step:"Schicht 1 · unten",  name:"Bestehender Untergrund",            h:"vorhanden",     body:"Fliesen, Estrich, Beton oder Holzdielen – das Dünnschichtsystem klebt direkt auf dem Bestand."}
    },
    klett: {
      belag:   {step:"Schicht 6 · oben",  name:"Bodenbelag",                        h:"frei wählbar",  body:"Fliesen, Parkett, Vinyl oder Laminat. Wärmewiderstand λ ≤ 0,15 m²K/W empfohlen."},
      estrich: {step:"Schicht 5",          name:"Dünnschicht-Estrich (Calciumsulfat-Ausgleichsmasse)",h:"≥ 5 mm",        body:"Schnellhärtende Calciumsulfat-Nivelliermasse. Begehbar nach 3 Stunden, Belag nach 4–12 Std."},
      rohr:    {step:"Schicht 4",          name:"Heizrohr PE-RT / PE-Xa",            h:"10 – 12 mm",    body:"Rohr wird direkt auf das gelochte Klettvlies gedrückt – kein Werkzeug nötig. Freier Rohrabstand wählbar."},
      folie:   {step:"Schicht 3",          name:"MC KLETT Vlies (gelocht, 2 mm)",    h:"2 mm",          body:"2mm dünnes, selbstklebendes Klettvlies. Perforation lässt den Estrich direkt mit dem Untergrund verkleben – flachste Klettsystem-Variante."},
      grund:   {step:"Schicht 2",          name:"Grundierung / Haftbrücke",          h:"hauchdünn",     body:"Untergrund reinigen und grundieren für optimale Haftung."},
      boden:   {step:"Schicht 1 · unten",  name:"Bestehender Untergrund",            h:"vorhanden",     body:"Direkt auf Fliesen, Estrich, Beton oder Holzdielen."}
    },
    /* ── Klettsystem ── */
    slim: {
      belag:   {step:"Schicht 6 · oben",  name:"Bodenbelag",                        h:"frei wählbar",  body:"Fliesen, Parkett, Vinyl oder Laminat – nach Estrich-Trocknungszeit verlegt. Wärmewiderstand λ ≤ 0,15 m²K/W empfohlen."},
      estrich: {step:"Schicht 5",          name:"Anhydritestrich (Fließestrich)",       h:"≥ 25 mm",   body:"Anhydritestrich (Fließestrich/CAF) vergießt das Heizrohr mit mindestens 25 mm Rohrüberdeckung – ideal für das Klettsystem. Hinweis nach DIN 18560-2: Bei Zementestrich sind mindestens 45 mm Rohrüberdeckung erforderlich; Trocknungszeit 21–28 Tage."},
      rohr:    {step:"Schicht 4",          name:"PE-Xa EVOH Heizrohr Ø 16 mm",       h:"16 mm",        body:"Sauerstoffdichtes PE-Xa EVOH Heizrohr – wird direkt in das Klettvlies eingedrückt. Kein Tackergerät nötig. Frei wählbarer Rohrabstand (typisch 10–30 cm). Max. 70 m pro Heizkreis."},
      folie:   {step:"Schicht 3",          name:"MC KLETT Slim Vlies",               h:"2 mm",         body:"Vollflächiges, selbstklebendes Klettvlies (2mm) – hält das Heizrohr durch Klettwirkung sicher an der gewünschten Position. Keine Noppenplatte, kein Tackergerät. Freier Rohrabstand, ideal für komplexe Grundrisse."},
      daemm:   {step:"Schicht 2",          name:"EPS-Dämmplatte WLG035 (optional)",  h:"0 – 50 mm",   body:"Optionale EPS-Trittschalldämmplatte nach GEG – erhöht die Wärmedämmung und erfüllt die Anforderungen nach EnEV/GEG. Bei Renovation über bestehendem Heizestrich oft weglassbar."},
      boden:   {step:"Schicht 1 · unten",  name:"Untergrund (Rohdecke / Estrich)",   h:"Bestand",      body:"Betonrohdecke, bestehender Estrich oder verdichteter Untergrund – das Klettsystem lässt sich mit optionaler PE-Trennfolie (0,2mm) auf nahezu jedem festen Untergrund verlegen."}
    },
    silent: {
      belag:   {step:"Schicht 6 · oben",  name:"Bodenbelag",                        h:"frei wählbar",  body:"Fliesen, Parkett, Vinyl oder Laminat. Wärmewiderstand λ ≤ 0,15 m²K/W empfohlen."},
      estrich: {step:"Schicht 5",          name:"Anhydritestrich (Fließestrich)",       h:"≥ 25 mm",   body:"Anhydritestrich (Fließestrich) mit mindestens 25 mm Rohrüberdeckung. Hinweis nach DIN 18560-2: Bei Zementestrich sind mindestens 45 mm Rohrüberdeckung erforderlich – in diesem Fall erhöht sich die Gesamtaufbauhöhe entsprechend."},
      rohr:    {step:"Schicht 4",          name:"PE-Xa EVOH Heizrohr Ø 16 mm",       h:"16 mm",        body:"Sauerstoffdichtes Heizrohr – einfach ins Klettvlies eindrücken. Freier Rohrabstand, kein Werkzeug."},
      folie:   {step:"Schicht 3",          name:"MC KLETT Silent Vlies (28 dB)",     h:"5 mm",         body:"5mm dickes Klettvlies mit integriertem 28dB Trittschallschutz nach DIN 4109. Ideal für Mehrfamilienhäuser, Eigentumswohnungen und Gewerbe. Erste Wahl überall wo Schallschutzanforderungen gelten."},
      daemm:   {step:"Schicht 2",          name:"EPS-Dämmplatte WLG035 (optional)",  h:"0 – 50 mm",   body:"Optionale zusätzliche EPS-Wärmedämmung – kombiniert mit dem Silent-Vlies erreichst du maximale Schall- und Wärmedämmwerte."},
      boden:   {step:"Schicht 1 · unten",  name:"Untergrund (Rohdecke / Estrich)",   h:"Bestand",      body:"Betonrohdecke oder bestehender Estrich als Basis."}
    },
    duennschicht: {
      belag:   {step:"Schicht 6 · oben",  name:"Bodenbelag",                        h:"frei wählbar",  body:"Fliesen, Parkett, Vinyl oder Laminat – nach kurzer Trocknungszeit direkt auf den Dünnschicht-Estrich verlegt. Wärmewiderstand λ ≤ 0,15 m²K/W empfohlen."},
      estrich: {step:"Schicht 5",          name:"Dünnschicht-Estrich (Calciumsulfat-Ausgleichsmasse)",h:"≥ 5 mm",       body:"Faserverstärkte Calciumsulfat-Ausgleichsmasse. Begehbar nach 3 Stunden, Belag nach 4–12 Std. belegreif. Ca. 1,4 kg/m² je mm Schichtdicke – etwas Reserve einplanen."},
      rohr:    {step:"Schicht 4",          name:"Heizrohr PE-Xa EVOH Ø 16 mm",       h:"10 – 16 mm",   body:"Rohr wird direkt auf das gelochte Klettvlies gedrückt – kein Werkzeug nötig. Freier Rohrabstand wählbar. Max. 70 m pro Heizkreis."},
      folie:   {step:"Schicht 3",          name:"MC KLETT Vlies (gelocht, 2 mm)",    h:"2 mm",         body:"2 mm dünnes, selbstklebendes Klettvlies. Die Perforation verbindet den Dünnestrich direkt mit dem Untergrund – sicherer Verbund ohne zusätzliche Befestigung. Schlankste Variante: ab 17 mm Gesamtaufbau."},
      grund:   {step:"Schicht 2",          name:"Grundierung / Haftbrücke",          h:"hauchdünn",    body:"Untergrund reinigen und grundieren, damit das MC KLETT Vlies und der Calciumsulfat-Ausgleichsmasse dauerhaft haften."},
      boden:   {step:"Schicht 1 · unten",  name:"Bestehender Untergrund",            h:"vorhanden",    body:"Fliesen, alter Estrich, Holzdielen oder Beton – das gelochte MC KLETT Vlies klebt direkt auf dem Bestand. Kein Abriss, kein schwerer Nassestrich."}
    },
    /* ── Noppensystem ── */
    '14mm': {
      belag:   {step:"Schicht 5 · oben",  name:"Bodenbelag",                                    h:"frei wählbar", body:"Fliesen, Naturstein, Parkett, Vinyl oder Laminat – nach der Estrich-Trocknungszeit (5–7 Tage bei CAF). Empfohlener Wärmewiderstand: λ ≤ 0,15 m²K/W."},
      estrich: {step:"Schicht 4",          name:"Fließestrich CAF (CA-C25-F5)",                 h:"≥ 35 mm",      body:"Calciumsulfat-Fließestrich mit mindestens 35 mm Überdeckung über dem Rohrscheitel (DIN 18560). Fließt blasenfrei um Rohr und Noppen. Belegreif in 5–7 Tagen bei +20 °C – deutlich schneller als Zementestrich."},
      rohr:    {step:"Schicht 3",          name:"Heizrohr Ø 16 mm (PE-RT, PE-Xa, Metallverbundrohr)", h:"16 mm",   body:"Sauerstoffdichtes Heizrohr – rastet direkt in die Noppengeometrie ein. Kein Werkzeug, keine Tackernadeln. Rohrabstand 100–300 mm frei wählbar, axiale und diagonale (45°) Verlegung möglich. Max. 70 m pro Heizkreis."},
      folie:   {step:"Schicht 2",          name:"Noppenplatte N-PS 1 mm + Randdämmstreifen",   h:"22 mm",        body:"PS-Folie (1 mm) mit 22 mm hohen Noppen. 14 Platten (1.450 × 850 mm) = 15,68 m² je Karton. Platten verbinden sich per Steckverbindung. Randdämmstreifen entkoppelt den Estrich von der Wand. Hinweis: keine integrierte Dämmung – separate Wärmedämmung unter der Platte erforderlich."},
      boden:   {step:"Schicht 1 · unten",  name:"Wärmedämmung + Untergrund (Rohdecke / Estrich)", h:"Bestand",   body:"Separate Wärmedämmung (EPS, PUR o.ä.) ist bauphysikalisch erforderlich und nicht im Komplettset enthalten. Untergrund muss eben, trocken und tragfähig sein (max. ±3 mm/2 m)."}
    },
    '16mm': {
      belag:   {step:"Schicht 5 · oben",  name:"Bodenbelag",                                    h:"frei wählbar", body:"Fliesen, Naturstein, Parkett, Vinyl oder Laminat – nach der Estrich-Trocknungszeit (21–28 Tage bei CT). Empfohlener Wärmewiderstand: λ ≤ 0,15 m²K/W."},
      estrich: {step:"Schicht 4",          name:"Zementestrich CT (CT-C25-F4)",                 h:"≥ 45 mm",      body:"Zementestrich mit mindestens 45 mm Überdeckung über dem Rohrscheitel (DIN 18560). Trocknungszeit 21–28 Tage bei +20 °C. Preisgünstiger als CAF, höhere Aufbauhöhe (ab 62 mm Gesamt)."},
      rohr:    {step:"Schicht 3",          name:"Heizrohr Ø 16 mm (PE-RT, PE-Xa, Metallverbundrohr)", h:"16 mm",   body:"Sauerstoffdichtes Heizrohr – rastet direkt in die Noppengeometrie ein. Rohrabstand 100–300 mm frei wählbar, axiale und diagonale (45°) Verlegung möglich. Max. 70 m pro Heizkreis."},
      folie:   {step:"Schicht 2",          name:"Noppenplatte N-PS 1 mm + Randdämmstreifen",   h:"22 mm",        body:"PS-Folie (1 mm) mit 22 mm hohen Noppen. 14 Platten (1.450 × 850 mm) = 15,68 m² je Karton. Platten verbinden sich per Steckverbindung. Randdämmstreifen entkoppelt den Estrich von der Wand. Hinweis: keine integrierte Dämmung – separate Wärmedämmung unter der Platte erforderlich."},
      boden:   {step:"Schicht 1 · unten",  name:"Wärmedämmung + Untergrund (Rohdecke / Estrich)", h:"Bestand",   body:"Separate Wärmedämmung (EPS, PUR o.ä.) ist bauphysikalisch erforderlich und nicht im Komplettset enthalten. Untergrund muss eben, trocken und tragfähig sein (max. ±3 mm/2 m)."}
    },
    /* ── Tackersystem ── */
    tacker: {
      belag:   {step:"Schicht 5 · oben",  name:"Bodenbelag",                            h:"frei wählbar", body:"Fliesen, Naturstein, Parkett, Vinyl oder Laminat – nach der Estrich-Trocknungszeit (21–28 Tage Zementestrich, 7–14 Tage Fließestrich). Empfohlener Wärmewiderstand: λ ≤ 0,15 m²K/W."},
      estrich: {step:"Schicht 4",          name:"Zementestrich (DIN 18560)",             h:"≥ 45 mm",      body:"Nassestrich nach DIN 18560-2 umschließt das Heizrohr vollständig – optimale Wärmeübertragung. Mindestüberdeckung über Rohrscheitel: 45 mm. Trocknungszeit 21–28 Tage (Zement) bzw. 7–14 Tage (Fließestrich). Vor dem Estrich: Dichtheitsprüfung bei 2,5-fachem Betriebsdruck für mind. 24 h."},
      rohr:    {step:"Schicht 3",          name:"PE-Xa EVOH Heizrohr Ø 16 mm",          h:"16 mm",        body:"Sauerstoffdichtes PE-Xa EVOH 5-Schicht-Heizrohr – mit Tackernadeln (35–60 mm) auf der EPS-Platte fixiert. Rohrabstand 75–200 mm im 5-cm-Raster frei wählbar. Max. 70 m pro Heizkreis für gleichmäßige Wärmeverteilung."},
      folie:   {step:"Schicht 2",          name:"EPS-Dämmplatte inkl. kaschierter Rasterfolie", h:"20–50 mm", body:"EPS-Trägerplatte (Rollbahn oder Faltplatte) mit aufgedrucktem 5-cm-Verlegeraster. Das werksseitig kaschierte Bändchengewebe dient als Trennlage nach DIN 18560 und ist tackerfähig. WLG035/040/045 je nach GEG-Anforderung; Druckfestigkeit sm4000 (4 kN/m²), sg5000 (5 kN/m²) oder sg10000 (10 kN/m²) je nach Belastung."},
      boden:   {step:"Schicht 1 · unten",  name:"Rohdecke / Untergrund",                 h:"Bestand",      body:"Betonrohdecke, bestehender Estrich oder Verbundestrich. Untergrund muss eben (max. ±3 mm/2 m), trocken und tragfähig sein. Bei feuchtem Untergrund empfehlen wir eine zusätzliche PE-Folie 0,2 mm als Dampfsperre unter der EPS-Dämmplatte."}
    }
  };

  var activeStack = document.getElementById('rgStack-noppe') ? 'noppe' : document.getElementById('rgStack-slim') ? 'slim' : document.getElementById('rgStack-tacker') ? 'tacker' : document.getElementById('rgStack-14mm') ? '14mm' : 'noppe';

  function initStack(stackId) {
    var stackEl  = document.getElementById('rgStack-'       + stackId);
    var detailEl = document.getElementById('rgLayerDetail-' + stackId);
    if(!stackEl) return;

    // Animate in
    stackEl.classList.remove('in');
    setTimeout(function(){ stackEl.classList.add('in'); }, 10);

    var data = layerDataByStack[stackId];
    function showL(key){
      var d = data[key]; if(!d||!detailEl) return;
      detailEl.innerHTML = '<div class="ld-card"><div class="ld-step">'+d.step+'</div><h3>'+d.name+'</h3><div class="ld-h">Schichtdicke: '+d.h+'</div><p>'+d.body+'</p></div>';
      stackEl.querySelectorAll('.rg-layer').forEach(function(l){
        l.classList.toggle('sel', l.getAttribute('data-layer')===key);
      });
    }
    stackEl.querySelectorAll('.rg-layer').forEach(function(l){
      // Remove old listeners by cloning
      var cl = l.cloneNode(true);
      l.parentNode.replaceChild(cl, l);
      cl.addEventListener('click',      function(){ showL(cl.getAttribute('data-layer')); });
      cl.addEventListener('mouseenter', function(){ showL(cl.getAttribute('data-layer')); });
    });
    showL('rohr');
  }

  // Observe first visible stack
  var firstStack = document.getElementById('rgStack-noppe') || document.getElementById('rgStack-slim') || document.getElementById('rgStack-tacker') || document.getElementById('rgStack-14mm');
  if(firstStack && 'IntersectionObserver' in window){
    var so = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ initStack(activeStack); so.disconnect(); }
      });
    },{threshold:0.2});
    so.observe(firstStack);
  } else if(firstStack){ initStack(activeStack); }

  // Tab switching
  document.querySelectorAll('.rg-aufbau-tab').forEach(function(btn){
    btn.addEventListener('click', function(){
      var newStack = btn.getAttribute('data-aufbau');
      if(newStack === activeStack) return;
      activeStack = newStack;

      // Update tab buttons
      document.querySelectorAll('.rg-aufbau-tab').forEach(function(b){
        b.classList.toggle('active', b === btn);
      });
      // Show/hide stack containers — dynamic, works for all templates
      document.querySelectorAll('[id^="rg-aufbau-"]').forEach(function(el){
        var elId = el.id.replace('rg-aufbau-', '');
        el.style.display = (elId === newStack) ? '' : 'none';
      });
      // Init newly visible stack
      initStack(newStack);
    });
  });

  /* ── Sticky CTA bar ────────────────────────────────────────────────── */
  var bar = document.getElementById("rgStickyCta");
  var heroEl = document.getElementById("rg-hero");
  var finalCtaEl = document.getElementById("rg-cta");
  var dismissed = false;
  var scClose = document.getElementById("rgScClose");
  if(scClose) scClose.addEventListener("click", function(){ dismissed=true; if(bar) bar.classList.remove("show"); });
  function onScroll(){
    if(!bar||dismissed) return;
    var past = heroEl ? (heroEl.getBoundingClientRect().bottom < 80) : (window.scrollY > 500);
    var atFinal = finalCtaEl ? (finalCtaEl.getBoundingClientRect().top < window.innerHeight - 40) : false;
    bar.classList.toggle("show", past && !atFinal);
  }
  window.addEventListener("scroll", onScroll, {passive:true});
  onScroll();

  /* ── Calculator ────────────────────────────────────────────────────── */
  var calc = document.getElementById("rgCalc");
  /* Skip if Klettsystem inline override is present (data-klett-calc attribute) */
  if(calc && calc.getAttribute("data-klett-calc") === "1") calc = null;
  if(calc){
    var state = {area:35, rohr:"1012", estrich:true};
    var setPrice = {"1012":9.80,"14":11.50,"16":12.90};
    var estrichPrice = {"1012":35.28,"14":39.20,"16":43.12};  /* 1,4 kg/mm x 18/20/22 mm x 1,40 EUR/kg */
    function fmt(n){ return n.toLocaleString("de-DE",{maximumFractionDigits:0}); }
    function fmt2(n){ return n.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2}); }
    function discRate(a){ return a>=100?0.10:a>=50?0.07:a>=20?0.05:a>=10?0.03:0; }
    function recompute(){
      var a=state.area, sp=setPrice[state.rohr];
      var setTotal=a*sp, estTotal=state.estrich?a*(estrichPrice[state.rohr]||estrichPrice['16']):0;
      var gross=setTotal+estTotal, rate=discRate(a), disc=gross*rate, net=gross-disc;
      var tEl=document.getElementById("rgCrTotal"); if(tEl) tEl.innerHTML='<span class="cur">€</span>'+fmt(net);
      var pEl=document.getElementById("rgCrPer"); if(pEl) pEl.textContent="≈ "+fmt2(net/a)+" €/m² · für "+fmt(a)+" m²";
      var rS=document.getElementById("rgRowSet"); if(rS) rS.textContent="€ "+fmt(setTotal);
      var rEW=document.getElementById("rgRowEstrichWrap"),rE=document.getElementById("rgRowEstrich");
      if(rEW) rEW.style.display=state.estrich?"":"none";
      if(rE&&state.estrich) rE.textContent="€ "+fmt(estTotal);
      var rDW=document.getElementById("rgRowDiscWrap"),rD=document.getElementById("rgRowDisc");
      if(rDW) rDW.style.display=rate>0?"":"none";
      if(rD&&rate>0) rD.textContent="− € "+fmt(disc)+"  ("+Math.round(rate*100)+"%)";
      var cEl=document.getElementById("rgCrCircuits");
      if(cEl){ var c=Math.max(1,Math.ceil(a/10)); cEl.textContent=c+(c===1?" Heizkreis":" Heizkreise"); }
    }
    function setArea(v){
      v=Math.max(5,Math.min(300,Math.round(v||0))); state.area=v;
      var rng=document.getElementById("rgCalcRange"), inp=document.getElementById("rgCalcInput");
      if(rng) rng.value=v;
      if(inp && document.activeElement!==inp) inp.value=v;
      recompute();
    }
    var rng=document.getElementById("rgCalcRange"), inp=document.getElementById("rgCalcInput");
    if(rng) rng.addEventListener("input",function(){ setArea(+rng.value); if(inp) inp.value=state.area; });
    if(inp){ inp.addEventListener("input",function(){ setArea(+inp.value); }); inp.addEventListener("blur",function(){ inp.value=state.area; }); }
    document.querySelectorAll("[data-rg-rohr]").forEach(function(b){
      b.addEventListener("click",function(){
        state.rohr=b.getAttribute("data-rg-rohr");
        document.querySelectorAll("[data-rg-rohr]").forEach(function(x){ x.classList.remove("on"); });
        b.classList.add("on"); recompute();
      });
    });
    var estToggle=document.getElementById("rgEstToggle");
    if(estToggle) estToggle.addEventListener("click",function(){
      state.estrich=!state.estrich;
      estToggle.classList.toggle("on",state.estrich);
      estToggle.setAttribute("aria-checked",state.estrich?"true":"false");
      recompute();
    });
    setArea(35);
  }
});
})();
